import React from 'react';

import { connect } from 'react-redux';
import { compose } from 'recompose';

import SubPageTitle from '../../../layouts/Portal/SubPageTitle';
import { storeSelectors } from '../../../selectors';
import { dateTimeUtils } from '../../../selectors/localeDateTime.selector';

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState, { storeId }: Props) => {
  const envTimeZones = storeSelectors.envTimeZones(state, { storeId });

  return {
    envTimeZones,
    dtUtils: dateTimeUtils(state),
  };
};

type Props = { storeId: number };
const Title = compose<Props & MappedState, Props>(connect(mapStateToProps))(() => {
  return (
    <>
      <SubPageTitle translateId="Opening_hour_overrides_title" />
    </>
  );
});

export default Title;
